export interface ISelectedFiltersDetails {
    label: string;
    values: string[];
}

export function AppliedFiltersDetailsBody(props: { details?: ISelectedFiltersDetails[] }) {
    const isEmpty = props.details?.every((detail) => detail.values.length === 0);

    if (isEmpty) {
        return <div>No filters selected</div>;
    }

    return (
        <>
            {props.details?.map(
                (detail, index) =>
                    detail.values.length > 0 && (
                        <div key={index} style={{ marginBottom: '1rem' }}>
                            <div className="uppercase bold">{detail.label}</div>
                            <ul>
                                {detail.values.map((value, idx) => (
                                    <li key={idx}>{value}</li>
                                ))}
                            </ul>
                        </div>
                    )
            )}
        </>
    );
}
